import "./styles.css";
import React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function CalendarPicker({
  label,
  isDisabled,
  isStanAlone,
  isDisablePast,
  onSelected,
  value,
  maxDate,
}) {
  return (
    <div className="calendar-container" id="calendar-container">
      <p className="label" id="calendar-title">
        {label}
      </p>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        id="calendar-localization-provider"
      >
        <DatePicker
          value={value}
          onChange={(newValue, str) => onSelected(newValue, str)}
          inputFormat="DD-MM-YYYY"
          renderInput={(params) => <TextField {...params} />}
          className={"calendar"}
          disabled={isDisabled}
          disablePast={isDisablePast}
          maxDate={maxDate}
          id="calendar-picker"
        />
      </LocalizationProvider>
    </div>
  );
}
